module.exports = __webpack_public_path__ + "static/media/course commercial script and graphics edits_1618236872934.fad770f1.docx";